var _style, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _polygon2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBetterlesson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 494.9 103.8",
    style: {
      enableBackground: "new 0 0 494.9 103.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#1B7CD9;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n")), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "87.2,64.8 87.2,73.1 58.4,73.1 58.4,28.3 67.2,28.3 67.2,64.8  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.6,50c4.8,1.3,8,5.6,7.9,10.6c0,7.3-5.5,12.5-13.8,12.5H22.3V28.3h16.1c8.7,0,13.7,5.1,13.7,12.1 C52.2,44.7,49.6,48.5,45.6,50z M44.8,60c0-3.6-2.3-6-6.7-6h0h-7.2v11.8H38C42.2,65.8,44.8,63.6,44.8,60z M43.5,41.2 c0-3.4-2.2-5.6-6.5-5.6h-6.1v11.2h6.2C41.1,46.8,43.5,44.6,43.5,41.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.9,53v19.8h-8.5V54.5c0-3.5-1.7-6.3-5.8-6.3c-3.7,0-5.9,2.9-5.9,6.5v18.1h-8.5V41.4h8.3v3.9 c1.9-3.3,5.7-4.7,9.1-4.7C491.3,40.6,494.9,46.1,494.9,53z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M444.2,40.4c9.4,0,16.5,7,16.5,16.7c0,9.7-7.1,16.7-16.5,16.7s-16.5-7-16.5-16.7S434.8,40.4,444.2,40.4z  M452.2,57.1c0-6-3.8-9-8-9s-8,3-8,9s3.8,9,8,9S452.2,63.1,452.2,57.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M424.3,49.5l-7.1,1.6c-0.3-2.6-2.6-4.4-5.2-4.2c-2.2,0-4,1.3-4,3.1c0,1.5,1.1,2.5,2.9,2.8l4.5,1 c6.2,1.3,9.3,5.1,9.3,9.7c0,5.1-4,10.4-12.2,10.4c-9.5,0-12.7-6.1-13.1-9.7l7.2-1.6c0.2,2.5,2,4.8,5.8,4.8c2.8,0,4.2-1.5,4.2-3.1 c0-1.4-1-2.6-3.4-3.1l-4.2-1c-6.1-1.3-8.8-5-8.8-9.4c0-5.6,5-10.3,11.8-10.3C420.9,40.4,423.9,46.1,424.3,49.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.5,63.5c0,5.1-4,10.4-12.2,10.4c-9.5,0-12.7-6.1-13.1-9.7l7.2-1.6c0.2,2.5,2,4.8,5.8,4.8 c2.8,0,4.2-1.5,4.2-3.1c0-1.4-1-2.6-3.4-3.1l-4.2-1c-6.1-1.3-8.8-5-8.8-9.4c0-5.6,5-10.3,11.8-10.3c9,0,12,5.7,12.4,9.1l-7.1,1.6 c-0.3-2.6-2.6-4.4-5.2-4.2c-2.2,0-4,1.3-4,3.1c0,1.5,1.1,2.5,2.9,2.8l4.5,1C393.3,55.1,396.5,58.9,396.5,63.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.3,56.8c0,1.2-0.1,2.5-0.1,2.6h-22.5c0.3,4.1,3.8,7.3,7.9,7.2c4,0,6.1-2,7.2-4.8l7.1,2.1 c-1.6,5.4-6.6,10-14.3,10c-8.6,0-16.2-6.2-16.2-16.8c0-10,7.4-16.6,15.5-16.6C362.5,40.5,368.3,46.7,368.3,56.8z M345.9,53.6h14 c-0.1-3.1-2.2-6.2-7-6.2C349.3,47.2,346.3,50,345.9,53.6z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "334.7,64.4 334.7,72.9 305.7,72.9 305.7,27.5 314.5,27.5 314.5,64.4  "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.5,41.3l-0.1,8.6c-0.8-0.2-1.7-0.3-2.6-0.3c-4.4,0-8.1,2.1-8.1,8.9v14.4h-8.5V41.4h8.3v4.7 c1.9-4.2,6.3-4.9,9-4.9C299.2,41.2,299.9,41.2,300.5,41.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.9,56.8c0,1.2-0.1,2.5-0.1,2.6h-22.5c0.3,4.1,3.8,7.3,7.9,7.2c4,0,6.1-2,7.2-4.8l7.1,2.1 c-1.6,5.4-6.6,10-14.3,10c-8.6,0-16.2-6.2-16.2-16.8c0-10,7.4-16.6,15.5-16.6C270,40.5,275.9,46.7,275.9,56.8z M253.5,53.6h14 c-0.1-3.1-2.2-6.2-7-6.2C256.9,47.2,253.8,50,253.5,53.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.6,41.4V49h-6.3v13.2c0,2.7,1.3,3.6,3.7,3.6c0.9,0,1.8-0.1,2.6-0.3v7c-1.5,0.6-3.2,0.8-4.8,0.8 c-6.1,0-10-3.7-10-9.7V49H221v-7.5h1.6c3.3,0,4.9-2.2,4.9-5V32h7.7l0,9.4H241.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219,41.4V49h-6.3v13.2c0,2.7,1.3,3.6,3.7,3.6c0.9,0,1.8-0.1,2.6-0.3v7c-1.5,0.6-3.2,0.8-4.8,0.8 c-6.1,0-10-3.7-10-9.7V49h-5.7v-7.5h1.6c3.3,0,4.9-2.2,4.9-5V32h7.7l0,9.4H219z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.7,56.8c0,1.2-0.1,2.5-0.1,2.6H174c0.3,4.2,3.8,7.3,8,7.2c4,0,6.1-2,7.2-4.8l7.1,2.1 c-1.6,5.4-6.6,10-14.3,10c-8.6,0-16.2-6.2-16.2-16.8c0-10,7.4-16.6,15.5-16.6C190.9,40.5,196.7,46.7,196.7,56.8z M174.3,53.6h14 c-0.1-3.1-2.2-6.2-7-6.2C177.7,47.2,174.6,50,174.3,53.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.1,49.5c4.9,1.3,8.2,5.7,8,10.8c0,7.4-5.5,12.7-14,12.7h-17.5V27.5h16.3c8.8,0,13.8,5.2,13.8,12.2 C160.8,44,158.2,48,154.1,49.5z M153.3,59.6c0-3.7-2.3-6.1-6.7-6.1h-7.3v12l7.2,0C150.7,65.5,153.3,63.3,153.3,59.6z M152,40.6 c0-3.5-2.2-5.6-6.5-5.6h-6.2v11.3h6.3C149.6,46.3,152,44,152,40.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.84,
    y1: 6.84,
    x2: 96.74,
    y2: 96.74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A7CD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#1974CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#1660AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#155CA8"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.8,15L103.8,15l0,73.8c0,8.3-6.7,15-15,15H15c-8.3,0-15-6.7-15-15V15C0,6.7,6.7,0,15,0h73.8 C97.1,0,103.8,6.7,103.8,15z M87.2,73.1v-8.3h-20V28.3h-8.7v44.8H87.2z M53.5,60.6c0.2-4.9-3.1-9.3-7.9-10.6c4-1.5,6.6-5.3,6.5-9.6 c0-7-4.9-12.1-13.7-12.1H22.3v44.8h17.3C48,73.1,53.5,67.9,53.5,60.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -5.0348,
    y1: 18.7148,
    x2: 84.8652,
    y2: 108.6148
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A7CD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#1974CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#1660AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#155CA8"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.1,54c4.4,0,6.7,2.4,6.7,6c0,3.6-2.5,5.8-6.8,5.8h-7.1V54H38.1L38.1,54z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.0508,
    y1: 9.6292,
    x2: 93.9508,
    y2: 99.5292
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A7CD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#1974CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#1660AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#155CA8"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37,35.6c4.2,0,6.5,2.2,6.5,5.6c0,3.4-2.4,5.6-6.4,5.6h-6.2V35.6H37z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetterlesson);
export default __webpack_public_path__ + "static/media/betterlesson.44cd41df8c81badb3d7d76e0470b9ca5.svg";
export { ForwardRef as ReactComponent };